
import { useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ValueProposition from './components/ValueProposition';
import ProductSeries from './components/ProductSeries';
import ScienceSection from './components/ScienceSection';
import UserTestimonials from './components/UserTestimonials';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ScrollToTopButton from '../../components/base/ScrollToTopButton';

export default function Home() {
  useEffect(() => {
    // 设置首页SEO数据
    document.title = '燃轻元 - 科学之下的轻松哲学';
    
    // 更新meta描述
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '燃轻元 - 科学之下的轻松哲学，让体重管理成为一种快乐的生活方式。专业团队研发的天然健康产品，陪伴您的轻松健康之旅。');
    }
    
    // 更新关键词
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '燃轻元,茶膏，黑珍珠，体重管理,健康减肥,天然成分,科学减重,健康生活,营养补充');
    }
    
    // 添加Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "燃轻元",
      "description": "科学之下的轻松哲学，让体重管理成为一种快乐的生活方式",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "logo": "https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/58ab3c2c100cfeefc13e4dde60a3c9a8.png",
      "foundingDate": "2024",
      "sameAs": [],
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "CN"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": "Chinese"
      }
    });
    
    // 移除之前的JSON-LD脚本
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(script => script.remove());
    
    document.head.appendChild(script);
    
    return () => {
      // 清理
      const scriptToRemove = document.querySelector('script[type="application/ld+json"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <ValueProposition />
      <ProductSeries />
      <ScienceSection />
      <UserTestimonials />
      <CTASection />
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}
